import { render, staticRenderFns } from "./ViewLabourerTakeonPage.vue?vue&type=template&id=8531cfa4&scoped=true&"
import script from "./ViewLabourerTakeonPage.vue?vue&type=script&lang=js&"
export * from "./ViewLabourerTakeonPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8531cfa4",
  null
  
)

export default component.exports